import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminArtistsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('artist');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
